import React, { useEffect, useState } from "react";

import KogInputText from "@/main/components/shared/inputText/inputText";
import { KeyValue } from "@/main/models/common";
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";
import RenderTooltipMessage from "@/main/components/shared/renderTooltipMessage/renderTooltipMessage";

interface IInputMappingPartProps {
	searchText: string;
	watcherSupplier: null | KeyValue;
	setSearchText: React.Dispatch<React.SetStateAction<string>>;
}
function InputMappingPart({ searchText, watcherSupplier, setSearchText }: IInputMappingPartProps) {
	const translateWhatNeed = getTranslateByKey("information.whatDoyouNeed");
	const translateWhatNeedExample = getTranslateByKey("information.whatDoyouNeedExample");

	const [debouncedTerm, setDebouncedTerm] = useState("");
	const [label, setLabel] = useState(`${translateWhatNeed} ${translateWhatNeedExample}`);

	const DEBOUNCE_DELAY = 500;

	const handleInputChange = (value: string) => {
		setDebouncedTerm(value);
	};

	useEffect(() => {
		if (!debouncedTerm) {
			setSearchText("");
		}

		const handler = setTimeout(() => {
			setSearchText(debouncedTerm);
		}, DEBOUNCE_DELAY);

		return () => {
			clearTimeout(handler);
		};
	}, [debouncedTerm]);

	useEffect(() => {
		setDebouncedTerm(searchText);
	}, [searchText]);

	const hasSupplier = !isNullUndefined(watcherSupplier);
	const messageTooltipInput = hasSupplier ? "" : getTranslateByKey("information.selectASupplierToSearch");

	return (
		<RenderTooltipMessage followCursor withClick tooltipMessage={messageTooltipInput} placement="top">
			<KogInputText
				disabled={!hasSupplier}
				value={debouncedTerm}
				onChangeCustom={handleInputChange}
				onFocus={() => {
					setLabel(translateWhatNeed);
				}}
				onBlur={() => {
					if (debouncedTerm === "") setLabel(`${translateWhatNeed} ${translateWhatNeedExample}`);
				}}
				label={label}
			/>
		</RenderTooltipMessage>
	);
}

export default InputMappingPart;
